/* eslint-disable */
export default {
  dialer: 'Dialpad',
  allCalls: 'All Calls',
} as const;

// @key: @#@"dialer"@#@ @source: @#@"Dial Pad"@#@
// @key: @#@"allCalls"@#@ @source: @#@"All Calls"@#@
